import React from "react"
import {Link} from 'gatsby'

export default () => {
  return (
    <footer className="bot-footer">Millionaire Millennial © {new Date().getFullYear()} <Link to="/privacy-policy">Terms & Privacy</Link></footer>
  )
}
